// @ts-nocheck
/* eslint-disable */
export const llaPlatformRedoIcon = {
    data: `<svg viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.59961 7.84998L7.84961 5.72498L5.59961 3.59998" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.84961 5.72498H2.59961C1.49504 5.72498 0.599609 4.82955 0.599609 3.72498V0.599976" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'redo' as const
};